import React from 'react';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '../../MetricLoader';
import moment from 'moment-timezone';
import ComparisonMetric from '../../ComparisonMetric';
import useInvitationsResponded from './useInvitationsResponded';
import useInvitationsCreated from './useInvitationsCreated';

export default function PercentPartnerInvitationsResponded(props) {
  const { network, schoolStart, schoolEnd, titleOnly = false } = props;

  const title = `% invitations responded to (by partner, system, or steward)`;

  const previousSchoolStart = moment(schoolStart).subtract(1, 'year').toISOString();

  const previousResponded = useInvitationsResponded(network, {
    start: titleOnly ? undefined : previousSchoolStart,
    end: schoolStart
  });

  const newResponded = useInvitationsResponded(network, {
    start: schoolStart,
    end: schoolEnd
  });

  const previousCreated = useInvitationsCreated(network, {
    start: titleOnly ? undefined : previousSchoolStart,
    end: schoolStart
  });

  const newCreated = useInvitationsCreated(network, {
    start: schoolStart,
    end: schoolEnd
  });

  if (
    previousCreated.state === PayloadStates.FETCHING ||
    newCreated.state === PayloadStates.FETCHING ||
    previousResponded.state === PayloadStates.FETCHING ||
    newResponded.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name={title}
      />
    );
  }

  const newPercent = Math.ceil(newResponded.meta.totalCount / newCreated.meta.totalCount * 100);
  const previousPercent = Math.ceil(previousResponded.meta.totalCount / previousCreated.meta.totalCount * 100);

  return (
    <ComparisonMetric
      name={title}
      value={newPercent}
      previousValue={previousPercent}
      titleOnly={titleOnly}
      percent={true}
    />
  );
}
